<template>
  <div class="flex">
    <div
      class="flex flex-col mx-auto p-4 w-full h-full items-center text-blue-800 my-4"
      style="text-align: center"
    >
      <div class="flex flex-col w-full px-12 gap-2">
        <div class="grid grid-cols-1 gap-2">
          <p class="col-span-1 text-left text-xl font-bold">
            {{ $t("bodyprint_queue.get_bodyprints") }}
          </p>
          <div class="content-start p-4 bg-gray-200">
            <div class="w-full flex flex-row justify-between items-center">
              <div class="flex flex-row w-full gap-4">
                <div class="flex flex-col items-start flex-1 w-1/4">
                  <label
                    for="email"
                    class="block font-medium text-sm text-gray-700"
                    >{{ $t("bodyprint_queue.input.email.label") }}</label
                  >
                  <div class="flex flex-row justify-center w-full">
                    <input
                      @keyup.enter="getUsers()"
                      id="email"
                      v-model="filter.email"
                      :placeholder="
                        $t('bodyprint_queue.input.email.placeholder')
                      "
                      class="
                          w-full
                          h-10
                          mt-1
                          p-2
                          border-2 border-solid border-black
                          rounded-md
                          "
                    />
                  </div>
                </div>
                <div
                  v-if="showRetailers && retailers.length > 0"
                  class="flex flex-col items-start flex-1 w-1/4"
                >
                  <label
                    for="retailer"
                    class="block font-medium text-sm text-gray-700"
                    >{{ $t("bodyprint_queue.input.retailer.label") }}</label
                  >
                  <div class="flex flex-row justify-center w-full">
                    <v-select
                      id="retailer"
                      v-model="selectedRetailer"
                      :options="retailers"
                      label="company_name"
                      :placeholder="
                        $t('bodyprint_queue.input.retailer.no_selection')
                      "
                      :searchable="false"
                      @input="onRetailerSelect"
                      class="w-full mt-1 tailie-select"
                    />
                  </div>
                </div>

                <div class="flex flex-col items-start flex-1 w-1/4">
                  <label
                    for="retailer_code"
                    class="block font-medium text-sm text-gray-700"
                    >{{
                      $t("bodyprint_queue.input.retailer_code.label")
                    }}</label
                  >
                  <div class="flex flex-row justify-center w-full">
                    <v-select
                      id="retailer_code"
                      v-model="selectedRetailerCode"
                      :options="retailerCodes"
                      label="code"
                      :placeholder="
                        $t('bodyprint_queue.input.retailer_code.no_selection')
                      "
                      :filterable="true"
                      @input="onRetailerCodeSelect"
                      class="w-full mt-1 tailie-select"
                    >
                      <template #no-options>
                        {{
                          $t("bodyprint_queue.input.retailer_code.no_options")
                        }}
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="flex flex-col items-start flex-1 w-1/4">
                  <label
                    for="status"
                    class="block font-medium text-sm text-gray-700"
                    >{{
                      $t("bodyprint_queue.input.measurement_status.label")
                    }}</label
                  >
                  <div class="flex flex-row justify-center w-full">
                    <v-select
                      id="status"
                      v-model="selectedMeasurementStatus"
                      :options="queueStatusFilterOptions"
                      label="label"
                      :placeholder="
                        $t(
                          'bodyprint_queue.input.measurement_status.no_selection'
                        )
                      "
                      :searchable="false"
                      @input="onMeasurementStatusSelect"
                      class="w-full mt-1 tailie-select"
                    />
                  </div>
                </div>
              </div>
              <div class="flex flex-col items-center mx-4">
                <button
                  @click="getUsers()"
                  :class="{
                    'w-24 h-10 text-md px-2 mx-2 text-white': true,
                    'bg-blue-800':
                      emailFilled ||
                      codeFilled ||
                      statusFilled ||
                      retailerFilled,
                    'bg-gray-600':
                      !emailFilled &&
                      !codeFilled &&
                      !statusFilled &&
                      !retailerFilled
                  }"
                  :disabled="
                    !emailFilled &&
                      !codeFilled &&
                      !statusFilled &&
                      !retailerFilled
                  "
                >
                  {{ $t("bodyprint_queue.buttons.search") }}
                </button>
                <button
                  class="w-24 h-10 text-md px-3 mx-2"
                  @click="clearSearch()"
                >
                  {{ $t("bodyprint_queue.buttons.clear") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-3 gap-4">
          <!--        Users list -->
          <div class="col-span-1 w-full border-solid border-2 self-start">
            <div v-if="usersLoading" class="p-4 text-left">
              {{ $t("bodyprint_queue.users_table.loading") }}
            </div>

            <div v-else>
              <div class="flex items-center justify-between py-4 px-4">
                <p class="text-left font-bold">
                  {{ $t("bodyprint_queue.users_table.header") }}
                </p>
                <button
                  class="text-sm px-2 py-1 border rounded bg-blue-800 text-white"
                  @click="userSortOrderAscending = !userSortOrderAscending"
                >
                  {{ userSortOrderAscending ? "A-Z ↑" : "Z-A ↓" }}
                </button>
              </div>
              <div v-if="users.length === 0" class="mb-4">
                {{ $t("bodyprint_queue.users_table.no_users_found") }}
              </div>
              <div class="flex flex-col max-h-full overflow-hidden px-4">
                <div
                  class="w-full border-solid mt-3 data-table-left-section overflow-y-auto table-parent"
                >
                  <div
                    v-for="(user, index) in this.sortedUsers"
                    :key="index"
                    @click="selectedUser = user"
                    v-bind:class="[
                      'cursor-pointer hover:bg-gray-50 py-3 px-2 text-left text-sm',
                      selectedUser && selectedUser.id === user.id
                        ? 'font-bold'
                        : 'font-normal',
                      sortedUsers !== undefined &&
                      index === sortedUsers.length - 1
                        ? ''
                        : 'border-b'
                    ]"
                  >
                    {{ user.email }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Selected user info -->
          <div class="col-span-2">
            <div v-if="!selectedUser">
              <div class="border-solid border-2 p-4 text-left">
                {{ $t("bodyprint_queue.selected_user.no_user_selected") }}
              </div>
            </div>
            <div v-else class="flex flex-col w-full gap-4">
              <div class="border-solid border-2 p-4 text-left">
                <b>{{ $t("bodyprint_queue.selected_user.user_selected") }}</b>
                {{ selectedUser.email }}
              </div>
              <div class="border-solid border-2 p-4 text-left">
                <body-print-queue-table
                  :queue-items="queueItems"
                  :queue-loading="queueLoading"
                  :selected-queue-item="selectedQueueItem"
                  @queue-item-selected="item => (selectedQueueItem = item)"
                />
              </div>

              <div class="border-solid border-2 p-4 text-left">
                <div v-if="!selectedQueueItem">
                  {{
                    $t(
                      "bodyprint_queue.measurements_table.no_bodyprint_selected"
                    )
                  }}
                </div>

                <div v-else>
                  <body-print-measurements-table
                    :items-for-queue="itemsForQueue"
                    :measurementsLoading="measurementsLoading"
                    @handle-view="
                      item => requestBodyprintToView(item.id, item.status)
                    "
                    @handle-edit="
                      item => requestBodyprint(item.id, item.status)
                    "
                    @handle-sizes="item => requestBodyprintSizes(item.id)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <error-modal
      :showModal="showErrorModal"
      :title="errorTitle"
      :message="errorMessage"
      @close="showErrorModal = false"
    />
    <measurements-modal
      :loading="sizesLoading"
      :showModal="showSizesModal"
      :bodyprintId="sizesBodyprintId"
      :data="sizesBodyprint"
      :onClose="
        () => {
          showSizesModal = false;
          sizesBodyprintId = null;
          sizesBodyprint = null;
        }
      "
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BodyPrintQueueTable from "@/components/bodyprint/bodyprint-queue-table.vue";
import BodyPrintMeasurementsTable from "@/components/bodyprint/bodyprint-measurements-table.vue";
import { ROUTE_BODYPRINT_CHECK, ROUTE_BODYPRINT_EDIT } from "@/router";
import MeasurementsModal from "@/components/modals/measurements-modal.vue";
import ErrorModal from "@/components/modals/error-modal.vue";
import { BodyprintQueueStatus } from "@/enums/modules/BodyprintQueueStatus";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "BodyprintQueueViewNew",
  components: {
    vSelect,
    MeasurementsModal,
    ErrorModal,
    BodyPrintMeasurementsTable,
    BodyPrintQueueTable
  },
  computed: {
    ...mapGetters({
      getAuthLoggedIn: "auth/getAuthLoggedIn",
      getAuth: "auth/getAuth",
      getUserData: "user/getUserData",
      getSidebarOpen: "layout/getSidebarOpen"
    }),
    ...mapActions(["auth/authCheck", "layout/toggleSidebar"]),
    sortedUsers() {
      const list = Array.isArray(this.users) ? [...this.users] : [];
      return list.sort((a, b) => {
        const ae = (a && a.email ? a.email : "").toString();
        const be = (b && b.email ? b.email : "").toString();
        const cmp = ae.localeCompare(be, undefined, { sensitivity: "base" });
        return !this.userSortOrderAscending ? -cmp : cmp;
      });
    }
  },
  data() {
    return {
      usersLoading: false,
      queueLoading: false,
      measurementsLoading: false,
      bodyprintLoading: false,
      loaded: false,
      failed: false,
      filter: {
        email: "",
        code: "",
        retailer: "",
        status: ""
      },
      selectedRetailerCode: null,
      selectedRetailer: null,
      selectedMeasurementStatus: null,
      emailFilled: false,
      codeFilled: false,
      statusFilled: false,
      retailerFilled: false,
      users: [],
      queueItems: [],
      selectedUser: null,
      selectedQueueItem: null,
      itemsForQueue: [],
      bodyprint: null,
      retailers: [],
      retailerCodes: [],
      showRetailers: false,
      userSortOrderAscending: true,
      sizesLoading: false,
      showSizesModal: false,
      sizesBodyprint: null,
      sizesBodyprintId: null,
      queueStatusFilterOptions: [
        {
          label: this.$t("bodyprint_queue.filters.status.completed"),
          value: BodyprintQueueStatus.COMPLETED
        },
        {
          label: this.$t("bodyprint_queue.filters.status.incomplete"),
          value: BodyprintQueueStatus.INCOMPLETE
        },
        {
          label: this.$t("bodyprint_queue.filters.status.in_progress"),
          value: BodyprintQueueStatus.IN_PROGRESS
        },
        {
          label: this.$t("bodyprint_queue.filters.status.in_review"),
          value: BodyprintQueueStatus.IN_REVIEW
        },
        {
          label: this.$t("bodyprint_queue.filters.status.rejected"),
          value: BodyprintQueueStatus.REJECTED
        }
      ],
      isFirstChange: true,
      showErrorModal: false,
      errorTitle: "",
      errorMessage: ""
    };
  },
  methods: {
    getRetailerList() {
      this.$store.dispatch("retailer/getRetailerList").then(() => {
        this.showRetailers = true;
        this.retailers = this.$store.getters["retailer/getRetailers"];
      });
    },
    getRetailerCodes() {
      this.$store.dispatch("retailer/getRetailerCodesForMeasure").then(() => {
        this.retailerCodes = this.$store.getters["retailer/getRetailerCodes"];
      });
    },
    getFilterPayload(
      email = null,
      code = null,
      retailer = null,
      status = null
    ) {
      return {
        email: email || this.filter.email,
        code: code || this.filter.code,
        retailer: retailer || this.filter.retailer,
        status: status || this.filter.status
      };
    },
    onRetailerCodeSelect(selected) {
      this.filter.code = selected ? selected.code : "";
      this.getUsers();
    },
    onRetailerSelect(selected) {
      this.filter.retailer = selected ? selected._id : "";
      this.getUsers();
    },
    onMeasurementStatusSelect(selected) {
      this.filter.status = selected ? selected.value : "";
      this.getUsers();
    },
    getMeasurementsFilter(status = null) {
      return {
        status: status || this.filter.status
      };
    },
    getUsers() {
      this.usersLoading = true;
      this.selectedUser = null;
      this.selectedQueueItem = null;
      this.users = [];

      this.$store
        .dispatch("bodyprint/getAllUsersInQueue", this.getFilterPayload())
        .then(() => {
          this.users = this.$store.getters["bodyprint/getUsersInQueue"];
          this.usersLoading = false;
        });

      this.selectedUser =
        JSON.parse(localStorage.getItem("selectedUser")) ?? null;
    },
    clearSearch() {
      this.filter.email = "";
      this.filter.code = "";
      this.filter.status = "";
      this.filter.retailer = "";

      this.selectedRetailerCode = null;
      this.selectedRetailer = null;
      this.selectedMeasurementStatus = null;

      this.selectedUser = null;
      this.selectedQueueItem = null;

      localStorage.removeItem("selectedQueueItem");
      localStorage.removeItem("selectedUser");
      localStorage.removeItem("filter");

      this.getRetailerCodes();
      this.getRetailerList();
      this.getUsers();
    },
    requestBodyprintToView(id, currentStatus) {
      if (this.getSidebarOpen) {
        this.$store.dispatch("layout/toggleSidebar");
      }
      this.bodyprintLoading = true;

      this.$store
        .dispatch("bodyprint/requestBodyprintInfo", { id: id })
        .then(() => {
          const bodyprintInfo = this.$store.getters[
            "bodyprint/getBodyPrintInfo"
          ];

          if (this.checkQueueItemStatus(bodyprintInfo.status, currentStatus)) {
            this.$store
              .dispatch("bodyprint/requestBodyprintToView", { id: id })
              .then(() => {
                var bp = this.$store.getters["bodyprint/getBodyPrint"];
                if (bp.user) {
                  this.$store.dispatch("bodyprint/getBodyprintSizes", {
                    user: bp.user,
                    bodyprint: bp._id
                  });
                  this.$store
                    .dispatch("bodyprint/getBlurredImages", bp.user)
                    .then(() => {
                      this.$store
                        .dispatch("bodyprint/checkBodyprint")
                        .then(() => {
                          const pushToRoute = () => {
                            this.bodyprintLoading = false;
                            this.loaded = true;
                            this.$router.push({
                              name: ROUTE_BODYPRINT_CHECK,
                              params: { queue_id: id }
                            });
                          };

                          this.saveToLocalStorage();
                          pushToRoute();
                        });
                    })
                    .catch(() => {
                      this.bodyprintLoading = false;
                      this.failed = true;
                    });
                }
              })
              .catch(() => {
                this.bodyprintLoading = false;
                this.errorMessage = this.$t(
                  "bodyprint_queue.errors.could_not_find_bodyprint_user"
                );
              });
          } else {
            this.bodyprintLoading = false;
            this.showQueueItemStatusChangedErrorAndRefetch();
          }
        });
    },
    requestBodyprint(id, currentStatus) {
      if (this.getSidebarOpen) {
        this.$store.dispatch("layout/toggleSidebar");
      }
      this.bodyprintLoading = true;

      this.$store
        .dispatch("bodyprint/requestBodyprintInfo", { id: id })
        .then(() => {
          const bodyprintInfo = this.$store.getters[
            "bodyprint/getBodyPrintInfo"
          ];

          if (this.checkQueueItemStatus(bodyprintInfo.status, currentStatus)) {
            this.$store
              .dispatch("bodyprint/requestBodyprint", { id: id })
              .then(() => {
                var bp = this.$store.getters["bodyprint/getBodyPrint"];
                var qi = this.$store.getters["bodyprint/getQueueItem"];
                if (bp.user) {
                  this.$store.dispatch("bodyprint/getBodyprintSizes", {
                    user: bp.user,
                    bodyprint: bp._id
                  });
                  this.$store
                    .dispatch("bodyprint/getBlurredImages", bp.user)
                    .then(() => {
                      this.$store
                        .dispatch("bodyprint/editBodyprint")
                        .then(() => {
                          const pushToRoute = () => {
                            this.bodyprintLoading = false;
                            this.loaded = true;
                            this.$router.push({
                              name: ROUTE_BODYPRINT_EDIT,
                              params: { queue_id: qi._id }
                            });
                          };

                          this.saveToLocalStorage();
                          pushToRoute();
                        });
                    })
                    .catch(() => {
                      this.bodyprintLoading = false;
                      this.failed = true;
                    });
                }
              })
              .catch(() => {
                this.bodyprintLoading = false;
                this.errorMessage = this.$t(
                  "bodyprint_queue.errors.could_not_find_bodyprint_user"
                );
              });
          } else {
            this.bodyprintLoading = false;
            this.showQueueItemStatusChangedErrorAndRefetch();
          }
        });
    },
    requestBodyprintSizes(id) {
      this.sizesLoading = true;
      this.$store
        .dispatch("bodyprint/requestBodyprintSizes", { id: id })
        .then(() => {
          this.sizesLoading = false;
          this.showSizesModal = true;
          this.sizesBodyprintId = id;
          this.sizesBodyprint = this.$store.getters[
            "bodyprint/getBodyprintSizes"
          ];
        })
        .catch(() => {
          this.sizesBodyprintId = null;
          this.sizesBodyprint = null;
          this.sizesLoading = false;
          this.errorMessage = this.$t(
            "bodyprint_queue.errors.could_not_find_bodyprint_user"
          );
        });
    },
    saveToLocalStorage() {
      localStorage.setItem("selectedUser", JSON.stringify(this.selectedUser));
      localStorage.setItem(
        "selectedQueueItem",
        JSON.stringify(this.selectedQueueItem)
      );
      localStorage.setItem("filter", JSON.stringify(this.filter));
    },
    checkQueueItemStatus(newStatus, currentStatus) {
      return newStatus === currentStatus;
    },
    showQueueItemStatusChangedErrorAndRefetch() {
      this.errorTitle = this.$t(
        "bodyprint_queue.errors.queue_status_changed.title"
      );
      this.errorMessage = this.$t(
        "bodyprint_queue.errors.queue_status_changed.message"
      );
      this.showErrorModal = true;

      this.$store
        .dispatch("bodyprint/getMeasurementsForQueue", {
          email: this.selectedUser.email,
          code: this.selectedQueueItem.retailer_code,
          ...this.getMeasurementsFilter(this.filter.status)
        })
        .then(() => {
          this.itemsForQueue = this.$store.getters[
            "bodyprint/getItemsForQueueItem"
          ];

          this.measurementsLoading = false;
        });
    }
  },
  created() {
    if (!this.getSidebarOpen) {
      this.$store.dispatch("layout/toggleSidebar");
    }
    this.getRetailerCodes();
  },
  mounted() {
    this.filter = JSON.parse(localStorage.getItem("filter")) ?? this.filter;
    this.selectedMeasurementStatus = this.queueStatusFilterOptions.filter(
      item => {
        return item.value === this.filter.status;
      }
    );
    this.getUsers();
  },
  watch: {
    getUserData() {
      if (this.getUserData) {
        if (
          this.getUserData.roles.includes("admin") ||
          this.getUserData.roles.includes("employee")
        ) {
          this.getRetailerList();
        }
      }
    },

    filter: {
      handler(newFilter) {
        this.emailFilled = newFilter.email !== "";
        this.codeFilled = newFilter.code !== "";
        this.retailerFilled = newFilter.retailer !== "";
        this.statusFilled = newFilter.status !== "";
      },
      deep: true
    },

    selectedUser() {
      if (this.selectedUser) {
        this.queueLoading = true;

        this.$store
          .dispatch(
            "bodyprint/getBodyprintQueueForUser",
            this.getFilterPayload(this.selectedUser.email)
          )
          .then(() => {
            this.queueLoading = false;
            this.queueItems = this.$store.getters["bodyprint/getItemsForUser"];

            if (this.isFirstChange) {
              this.isFirstChange = false;
              this.selectedQueueItem =
                JSON.parse(localStorage.getItem("selectedQueueItem")) ?? null;
            } else {
              this.selectedQueueItem = null;
              localStorage.removeItem("selectedQueueItem");
              localStorage.removeItem("selectedUser");
            }
          });
      }
    },
    selectedQueueItem() {
      this.measurementsLoading = true;
      if (!this.selectedQueueItem) return;

      this.$store
        .dispatch("bodyprint/getMeasurementsForQueue", {
          email: this.selectedUser.email,
          code: this.selectedQueueItem.retailer_code,
          ...this.getMeasurementsFilter(this.filter.status)
        })
        .then(() => {
          this.itemsForQueue = this.$store.getters[
            "bodyprint/getItemsForQueueItem"
          ];

          this.measurementsLoading = false;
        });
    },
    retailers() {
      this.selectedRetailer = this.retailers.filter(item => {
        return item._id === this.filter.retailer;
      });
    },
    retailerCodes() {
      this.selectedRetailerCode = this.retailerCodes.filter(item => {
        return item.code === this.filter.code;
      });
    }
  }
};
</script>
